import React from "react";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";

/**
 * Get the navigation bar.
 */
export function NavigationBar({ actualNav, assetId, preferences }) {
  if (!assetId) {
    return null;
  }

  let navList = [
    { name: "Visão Geral", url: "", preferenceLabel: "generalOverview" },
    { name: "Saúde", url: "Health", preferenceLabel: "health" },
    { name: "Análise técnica", url: "Technicals", preferenceLabel: "technical" },
    { name: "Análise fundamentalista", url: "Fundamental", preferenceLabel: "fundamental" },
    { name: "Importantes", url: "Extra", preferenceLabel: "extra" },
  ];

  let touched = false;

  let navBar = navList.map((item, i) => {
    if (preferences[item.preferenceLabel] === false) {
      return null;
    }
    if (
      (actualNav === item.url && !touched) ||
      (actualNav === undefined && !touched)
    ) {
      touched = true;
      return (
        <span className="nav-link active" key={i} style={linkStyle()}>
          {item.name}
        </span>
      );
    } else {
      return (
        <Link to={"/analysis/" + assetId + "/" + item.url} key={i}>
          <span className="nav-link" key={i} style={linkStyle()}>
            {item.name}
          </span>
        </Link>
      );
    }
  });

  return (
    <div className="nav-wrapper-inside-page">
      <nav className="nav nav-inside-page" style={buttonStyle()}>
        {navBar}
      </nav>
    </div>
  );
}

export const NavigationBarMemo = React.memo(NavigationBar);

export function getSelectedTab({ actualTab }) {
  let showCards = {
    impressions: null,
    technical: null,
    fundamental: null,
    extra: null,
    generalOverview: null,
    health: null,
    tabSelected: false,
  };

  switch (actualTab) {
    case "Technicals": //Technicals
      showCards.technical = true;
      showCards.tabSelected = true;
      break;
    case "Fundamental": //Fundamental
      showCards.fundamental = true;
      showCards.tabSelected = true;
      break;
    case "Extra": //Others (EXTRA)
      showCards.extra = true;
      showCards.tabSelected = true;
      break;
    case "Health": // Health
      showCards.health = true;
      showCards.tabSelected = true;
      break;
    default:
      showCards = {
        impressions: true,
        technical: true,
        fundamental: true,
        extra: true,
        generalOverview: true,
        health: true,
        tabSelected: false,
      };
      break;
  }

  return showCards;
}

const linkStyle = () => {
  if (isMobile) {
    return {
      borderRadius: 15,
    };
  } else {
    return null;
  }
};

const buttonStyle = () => {
  if (isMobile) {
    return {
      backgroundColor: "var(--bg-8)",
      borderRadius: 15,
    };
  } else {
    return {
      backgroundColor: null,
      borderRadius: 10,
    };
  }
};
